import { FinalSubmittedComponentDetails } from "src/components/feature/MonitoringDetails/FinalSubmittedDetails";

export default function MonitoringSubmitted() {
  return <FinalSubmittedComponentDetails />;
}
